import { useEffect } from 'react'

const CURRENT_RELEASE = process.env.NEXT_PUBLIC_SENTRY_RELEASE

export function useReleaseAutoReload() {
  useEffect(() => {
    const checkForNewRelease = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' })
        const { release: latestRelease } = await res.json()
        if (latestRelease && latestRelease !== CURRENT_RELEASE) {
          window.location.reload()
        }
      } catch (err) {}
    }

    window.addEventListener('focus', checkForNewRelease)

    return () => {
      window.removeEventListener('focus', checkForNewRelease)
    }
  }, [])
}
